import { Component, OnInit } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { NewUiButton, translateSafely } from "@ankaadia/ankaadia-shared-frontend";
import { BillingTableType } from "@ankaadia/graphql";
import { TranslocoService } from "@jsverse/transloco";
import { MessageService, SelectItemGroup } from "primeng/api";

import { MultiSelectModule } from "primeng/multiselect";
import { catchError, of } from "rxjs";
import { WriteTablesService } from "../../shared/write-tables.service";
import { ExcelBaseComponent } from "../excel-base/excel-base.component";
import { BillingDataService } from "./billing-data.service";

import { TranslationKey, UTCDate } from "@ankaadia/ankaadia-shared";
import { CalendarModule } from "primeng/calendar";
import { DropdownModule } from "primeng/dropdown";
import { FloatLabel } from "primeng/floatlabel";
import { InputSwitchModule } from "primeng/inputswitch";
import { UtcFixDirective } from "../../shared/directives/utc-fix.directive";

@Component({
  selector: "app-billing-data",
  styleUrl: "./billing-data.component.scss",
  templateUrl: "./billing-data.component.html",
  imports: [
    CalendarModule,
    UtcFixDirective,
    FormsModule,
    MultiSelectModule,
    NewUiButton,
    DropdownModule,
    InputSwitchModule,
    FloatLabel,
  ],
})
export class BillingDataComponent extends ExcelBaseComponent implements OnInit {
  myDate: UTCDate[] | undefined;
  licensedOrganizations!: SelectItemGroup[];
  selectedOrganization!: string;
  includeVirtualBookings = false;
  allOrganizations = false;

  dateSelectorState = "";
  organizationSelectorState = "";
  tableSelectorState = "";

  tableTypes: any[] = Object.keys(BillingTableType).map((key) => {
    return { label: translateSafely(`billingTableType.${BillingTableType[key]}` as TranslationKey), value: key };
  });

  selectedTableType: string[];

  constructor(
    private readonly billingData: BillingDataService,
    override readonly transloco: TranslocoService,
    override readonly messageService: MessageService,
    private readonly writeTablesService: WriteTablesService
  ) {
    super(transloco, messageService);
  }

  ngOnInit(): void {
    this.getLicensedOrganizations();
  }

  resetDateSelector(): void {
    this.dateSelectorState = "";
  }

  resetOrganizationSelector(): void {
    this.organizationSelectorState = "";
  }

  resetTableSelector(): void {
    this.tableSelectorState = "";
  }

  getLicensedOrganizations(): void {
    this.billingData.getOrganizationData().subscribe((d) => {
      if (d) {
        this.licensedOrganizations = [
          {
            label: translateSafely("officeAddin.licensedOrganizations"),
            items: d.organizations
              .filter((x) => x.isLicensed)
              .map((org) => {
                return { label: org.name, value: org.organizationId, isLicensed: org.isLicensed };
              })
              .sort((a, b) => a.label.localeCompare(b.label)),
          },
        ];
      }
    });
  }

  getData(): void {
    let invalid = false;
    if (!this.myDate) {
      this.dateSelectorState = "invalid-entry";
      invalid = true;
    }
    if (!this.selectedTableType || this.selectedTableType.length === 0) {
      this.tableSelectorState = "invalid-entry";
      invalid = true;
    }
    if (!this.allOrganizations && !this.selectedOrganization) {
      this.organizationSelectorState = "invalid-entry";
      invalid = true;
    }

    if (invalid) return;
    this.setBusy(true);
    this.billingData
      .getBillingData(
        this.language,
        this.myDate?.[0],
        this.myDate?.[1] ?? this.myDate[0],
        this.selectedTableType.map((type) => type as BillingTableType),
        this.allOrganizations,
        this.selectedOrganization,
        this.includeVirtualBookings
      )
      .pipe(
        catchError((error) => {
          this.sendFailureMessage(error);
          this.setBusy(false);
          return of(null);
        })
      )
      .subscribe(async (d) => {
        if (d) {
          const result = await this.writeTablesService.writeDataToManyTables(d, false);
          this.sendTableUpdateMessage(result);
          this.setBusy(false);
        }
      });
  }
}
